/**
 * 音频格式检测工具
 * 用于检测浏览器支持的录音格式，并提供格式转换辅助功能
 */

/**
 * 检测浏览器支持的音频 MIME 类型
 * 优先选择阿里云听悟直接支持的格式，减少转码需求
 * @returns {string} 支持的 MIME 类型
 */
export function getSupportedMimeType() {
    // 优先级顺序：MP3 > MP4 > WebM > Ogg
    const types = [
        'audio/mpeg',           // MP3 - 阿里云直接支持，部分浏览器原生支持
        'audio/mp4',            // MP4/AAC - 阿里云支持，Safari/iOS 常用
        'audio/webm;codecs=opus', // WebM/Opus - Chrome/Firefox 默认格式
        'audio/webm',           // WebM - 通用 WebM 格式
        'audio/ogg;codecs=opus' // Ogg/Opus - Firefox 备选
    ];

    for (const type of types) {
        if (MediaRecorder.isTypeSupported(type)) {
            console.log('浏览器支持的音频格式:', type);
            return type;
        }
    }

    console.warn('浏览器不支持常见音频格式，使用默认格式');
    return '';
}

/**
 * 获取文件扩展名
 * @param {string} mimeType - MIME 类型
 * @returns {string} 文件扩展名
 */
export function getFileExtension(mimeType) {
    const mimeToExt = {
        'audio/mpeg': 'mp3',
        'audio/mp3': 'mp3',
        'audio/mp4': 'm4a',
        'audio/webm': 'webm',
        'audio/webm;codecs=opus': 'webm',
        'audio/ogg': 'ogg',
        'audio/ogg;codecs=opus': 'ogg',
        'audio/wav': 'wav'
    };

    return mimeToExt[mimeType] || 'webm';
}
